<template>
  <div class="ImageSliderMobile">
    <div class="overflow-x items" v-if="images" ref="slider" @scroll="handleScroll" @mousedown="mousedown" @mouseleave="mouseleave" @mouseup="mouseup" @mousemove="mousemove">
      <div class="d-flex" dir="ltr">
          <div :key="(image,index)" v-for="(image,index) in images">
            <a :href="image.link">
              <img v-lazy="$MEDIA + image.imageMobile" :alt="image.alt">
            </a>
          </div>
      </div>
    </div>
    <div class="overflow-auto" v-if="!images">
      <div class="d-flex" dir="ltr">
        <div>
          <img src="../assets/loader-m.jpg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSliderMobile',
  data () {
    return {
      isDown: false,
      startX: null,
      scrollLeft: null,
      interval: null
    }
  },
  props: {
    images: Array
  },
  methods: {
    mousedown: function (e) {
      this.isDown = true
      this.$refs.slider.classList.add('active')
      this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.scrollLeft = this.$refs.slider.scrollLeft
    },
    mouseleave: function () {
      this.isDown = false
      try {
        this.$refs.slider.classList.remove('active')
      } catch {}
    },
    mouseup: function () {
      this.isDown = false
      this.$refs.slider.classList.remove('active')
    },
    mousemove: function (e) {
      if (this.isDown) {
        e.preventDefault()
        const x = e.pageX - this.$refs.slider.offsetLeft
        const walk = (x - this.startX) * 2
        this.$refs.slider.scrollLeft = this.scrollLeft - walk
      }
    },
    handleScroll: function () {
      if (this.interval && this.$refs.slider.scrollLeft < -80) {
        clearInterval(this.interval)
        this.interval = null
      }
    }
  },
  unmounted () {
    clearInterval(this.interval)
    this.interval = null
  }
}
</script>

<style scoped>
img{
  width: 280px;
  height: 225px;
  padding: 4px;
  margin: 4px;
  border: solid 2px gray;
  border-radius: 24px;
}
.items {
  position: relative;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: all 0.2s;
  transform: scale(0.97);
  will-change: transform;
  user-select: none;
  cursor: pointer;
  scrollbar-width: none;
}

.items.active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1);
}

</style>
